module.exports = __webpack_public_path__ + "static/img/vub-logo-rgb.226305aa.png";